
<template>
  <div class="grid">
    <div class="col-12">
      <DataView :value="Products" :layout="Layout" v-if="Loading">
        <template #header>
          <div class="flex justify-content-end">
            <div class="border-bottom-1 surface-border">
              <span class="text-xl font-medium text-900">My Modules</span>
            </div>
            <DataViewLayoutOptions v-model="Layout" />
          </div>
        </template>
        <template #list>
          <div class="col-12">
            <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
              <Skeleton class="w-9 sm:w-16rem xl:w-10rem shadow-2 h-6rem block xl:block mx-auto border-round" />
              <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                  <Skeleton class="w-8rem border-round h-2rem" />
                  <Skeleton class="w-6rem border-round h-1rem" />
                  <div class="flex align-items-center gap-3">
                    <Skeleton class="w-6rem border-round h-1rem" />
                    <Skeleton class="w-3rem border-round h-1rem" />
                  </div>
                </div>
                <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                  <Skeleton class="w-4rem border-round h-2rem" />
                  <Skeleton shape="circle" class="w-3rem h-3rem" />
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #grid>
          <div class="col-12 sm:col-6 lg:col-12 xl:col-4 p-2">
            <div class="p-4 border-1 surface-border surface-card border-round">
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <Skeleton class="w-6rem border-round h-2rem" />
                <Skeleton class="w-3rem border-round h-1rem" />
              </div>
              <div class="flex flex-column align-items-center gap-3 py-5">
                <Skeleton class="w-9 shadow-2 border-round h-10rem" />
                <Skeleton class="w-8rem border-round h-2rem" />
                <Skeleton class="w-6rem border-round h-1rem" />
              </div>
              <div class="flex align-items-center justify-content-between">
                <Skeleton class="w-4rem border-round h-2rem" />
                <Skeleton shape="circle" class="w-3rem h-3rem" />
              </div>
            </div>
          </div>
        </template>
      </DataView>

      <DataView :value="Products" :layout="Layout" v-if="!Loading">
        <template #header>
          <div class="grid">
            <div class="col-6 sm:col-12 flex justify-content-start border-bottom-1 surface-border">
              <span class="text-xl font-medium text-900">My Online Modules</span>
            </div>
            <div class="col-6 sm:col-12 flex justify-content-end">
              <DataViewLayoutOptions v-model="Layout" />
            </div>
          </div>
        </template>

        <template #list="slotProps">
          <div class="col-12">
            <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
              <img class="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" :src="`${slotProps.data.productImageUrl}`" />
              <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                  <div class="text-2xl font-bold text-900">{{ slotProps.data.productDescription }}</div>
                  <Rating :modelValue="5" readonly :cancel="false"></Rating>
                  <div class="flex align-items-center gap-3">
                    <span class="flex align-items-center gap-2">
                      <i class="pi pi-book"></i>
                      <span class="font-semibold">Interactive Study Guide</span>
                    </span>
                    <!--<Tag :value="slotProps.data.inventoryStatus" :severity="getSeverity(slotProps.data)"></Tag>-->
                  </div>
                </div>
                <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                  <Button icon="pi pi-arrow-right" label="Get Started" iconPos="right" severity="secondary"  type="text" placeholder="Right"
                          @click="CourseStart(`${slotProps.data.productId}`, `${slotProps.data.productDescription}`)" :disabled="slotProps.data.productStatus == 2000"
                          ></Button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #grid="slotProps">
          <div class="col-12 sm:col-6 lg:col-12 xl:col-6 p-2">
            <div class="p-4 border-1 surface-border surface-card border-round">
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-book"></i>
                  <span class="font-semibold"> Interactive Study Guide</span>
                </div>
                <!--<Tag :value="slotProps.data.inventoryStatus" :severity="getSeverity(slotProps.data)"></Tag>-->
              </div>
              <div class="flex flex-column align-items-center gap-3 py-5">
                <img class="w-9 shadow-2 border-round" :src="`${slotProps.data.productImageUrl}`" style="max-height:275px; max-width:275px"/>
                <div class="text-2xl font-bold">{{ slotProps.data.productDescription }}</div>
                <Rating :modelValue="5" readonly :cancel="false"></Rating>
              </div>
              <div class="flex align-items-center justify-content-end">
                <Button icon="pi pi-arrow-right"  label="Get Started"   iconPos="right" severity="secondary" @click="CourseStart(`${slotProps.data.productId}`, `${slotProps.data.productDescription}`)" :disabled="slotProps.data.productStatus == 2000"></Button>
              </div>
            </div>
          </div>
        </template>
      </DataView>
    </div>
  </div>
</template>

<style>
  .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
    color: #f29217;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #9E9E9E;
    border-color: #9E9E9E;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #FF9800;
    border-color: #FF9800;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight {
    background: #FF5722;
    border-color: #FF5722;
    color: #ffffff;
  }

  .p-button:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #FF9800, 0 1px 2px 0 black;
  }
</style>

<script>
  import { ref } from "vue";

  export default {
  name: 'LearningModules',
    
    data: () => ({
      Products: [],
      Loading:true,
      Layout: ref('list')
    }),
    created() {

      this.$emit("set-nav", this.$route)

      var self = this;

      self.$http.get('/ELearning/Products', { params: { productCategory: 1000 }}).then(function (response) {
        self.Products = response.data
        self.Loading = false;
      })
    },
    methods: {
      CourseStart(productId, productName) {
        this.$router.push({ path: `/Courses`, query: { CourseId: productId, CourseName: productName }})
      }
    }
}</script>